import { useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import {
  workspaceError,
  workspaceRequest,
} from "../../services/workspaceAdmin";

export default function CreateWorkspaceModal({
  landlordId,
  onClose,
  onCreated,
}) {
  const [name, setName] = useState("");
  const [image, setImage] = useState(null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  async function create(event) {
    event.preventDefault();
    setSaving(true);
    setError("");
    try {
      const data = new FormData();
      data.append("name", name.trim());
      if (image) data.append("profileImage", image);
      await workspaceRequest(landlordId, "", { method: "POST", data });
      toast.success("Workspace created");
      onCreated();
    } catch (error) {
      setError(workspaceError(error));
    } finally {
      setSaving(false);
    }
  }
  return (
    <Modal
      show
      onHide={() => !saving && onClose()}
      centered
      backdrop={saving ? "static" : true}
    >
      <Modal.Header closeButton={!saving}>
        <Modal.Title>Add workspace</Modal.Title>
      </Modal.Header>
      <form onSubmit={create}>
        <Modal.Body>
          <p>
            The selected landlord will own this workspace. Their default
            services and tenant requirements will be applied.
          </p>
          <label className="form-label" htmlFor="new-workspace-name">
            Workspace name
          </label>
          <input
            id="new-workspace-name"
            className="form-control mb-3"
            autoFocus
            required
            maxLength={150}
            value={name}
            onChange={(event) => setName(event.target.value)}
            disabled={saving}
          />
          <label className="form-label" htmlFor="new-workspace-image">
            Workspace image (optional)
          </label>
          <input
            id="new-workspace-image"
            className="form-control"
            type="file"
            accept="image/png,image/jpeg"
            onChange={(event) => setImage(event.target.files[0] || null)}
            disabled={saving}
          />
          {error && (
            <p className="text-danger mt-3" role="alert">
              {error}
            </p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-light"
            disabled={saving}
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-dark"
            disabled={saving || !name.trim()}
          >
            {saving ? "Creating…" : "Create workspace"}
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
